export default {
  category: {},
  SelectedUser: {},
  UpdateCategory:{}
};
